var React = require('react');

function Bars (props) {
    return React.createElement("svg",props,[React.createElement("path",{"d":"M0 0h24v24H0z","key":0}),React.createElement("path",{"d":"M3 18h18v-2H3v2zm0-5h18v-2H3v2zm0-7v2h18V6H3z","key":1})]);
}

Bars.defaultProps = {"fill":"currentColor","viewBox":"0 0 24 24"};

module.exports = Bars;

Bars.default = Bars;
